



















































import { Component, Vue, Prop } from 'vue-property-decorator'
import BarChart from "@/components/chart/BarChart.vue";
import LineChart from "@/components/chart/LineChart.vue";
import PieChart from "@/components/chart/PieChart.vue";
import moment from 'moment'

@Component({
  components: { BarChart, LineChart, PieChart }
})
export default class ChartCard extends Vue {
  @Prop(String) title!: string
  @Prop(Object) chartData!: object
  @Prop(Object) chartOptions!: object
  @Prop(Boolean) isLoading!: boolean;
  @Prop(String) dateTo!: string
  @Prop(String) updatedAt!: string;
  @Prop(String) defaultType!: string
  @Prop(String) customSubtitle!: string

  type: string = 'bar';

  created() {
    if (this.defaultType)
      this.setTypeByDefault();
  }

  setTypeByDefault() {
    if (this.defaultType == 'bar')
      this.type='bar'

    if (this.defaultType == 'line')
      this.type='line'

    if (this.defaultType == 'pie')
      this.type='pie'
  }

  get isBar():boolean {
    return (this.type=='bar');
  }

  get isLine():boolean {
    return (this.type=='line');
  }

  get isPie():boolean {
    return (this.type=='pie');
  }

  get subtitle():string {

    if (this.customSubtitle)
      return this.customSubtitle

    if (!this.isPie)
      return 'w okresie od ' + moment(this.dateTo).subtract(19, "days").format('D MMMM YYYY') +' do '+moment(this.dateTo).format('D MMMM YYYY');
    else
      return '';
  }

  get tooltipToggleChartType():string {
    return (this.isBar) ? 'Przełącz na wykres liniowy' : 'Przełącz na wykres słupkowy';
  }

  get tooltipPrevText():string {
    return 'Pokaż wcześniejszy okres (od ' + moment(this.dateTo).subtract(39, "days").format('D MMMM YYYY') +')';
  }

  get tooltipNextText():string {
    return 'Pokaż kolejny okres (od ' + moment(this.dateTo).add(1, "days").format('D MMMM YYYY') +')';
  }

  get nextButtonDisabled():boolean {
    let dateToIsAfter = moment(this.dateTo).isAfter(moment().format('YYYY-MM-DD'));
    let dateToIsSame = moment(this.dateTo).isSame(moment().format('YYYY-MM-DD'));
    return (dateToIsAfter || dateToIsSame);
  }

  showPrevious() {
    this.$emit('showPrevious');
  }

  showNext() {
    this.$emit('showNext');
  }

  refresh() {
    this.$emit('refresh');
  }

  toggleChartType() {
    if (this.isBar)
      this.type='line';
    else
      this.type='bar';
  }
}
